import { getSessionStorage, removeSessionStorage } from 'assets/constant';
import { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { useUserState } from 'recoil/useUserState';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';
import { teacherInfoState } from 'recoil/subject/teacherInfoState';
import { sisCourseState } from 'recoil/subject/sisCourseState';
import NoticePopup from './common/NoticePopup';
import Footer from './shared/Footer';
import Header from './shared/Header';
import { Sidebar } from './shared/sidebar';

function PrivateRoute() {
  const [cookies, setCookies, removeCookies] = useCookies(['token']);
  const user = useRecoilValue(useUserState);
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const resetSubjectState = useResetRecoilState(subjectOptionDataState);
  const resetTeacherInfo = useResetRecoilState(teacherInfoState);
  const resetSisCourse = useResetRecoilState(sisCourseState);

  const accessToken = getSessionStorage();
  const refreshToken = cookies.refreshToken;

  const navigate = useNavigate();

  useEffect(() => {
    // 토큰이 둘중 한개라도 없으면 로그인 페이지로 이동 후, 토큰 삭제
    if (!accessToken) {
      removeSessionStorage();
      removeCookies('refreshToken');
      navigate('/login');
    }
  }, [navigate, accessToken, refreshToken, removeCookies]);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    prevPathRef.current = location.pathname;

    const wasOnAttendance = prevPath.startsWith('/attendance');
    const wasOnGrade = prevPath.startsWith('/grade');
    const isOnAttendance = location.pathname.startsWith('/attendance');
    const isOnGrade = location.pathname.startsWith('/grade');

    if ((wasOnAttendance && !isOnAttendance) || (wasOnGrade && !isOnGrade)) {
      resetSubjectState();
      resetTeacherInfo();
      resetSisCourse();

      Object.keys(sessionStorage)
        .filter((key) => key.startsWith('recoil_'))
        .forEach((key) => sessionStorage.removeItem(key));
    }
  }, [location.pathname, resetSubjectState, resetTeacherInfo, resetSisCourse]);

  return user ? (
    <>
      <Header />
      <NoticePopup />
      <Sidebar />
      <Outlet />
    </>
  ) : (
    <Navigate to='/login' replace={true} />
  );
}

export default PrivateRoute;
